import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ProductCategoryResponseModel } from '../../product-services/shared/models/productCategoryResponseModel';
import { ProductServicesRequestModel } from '../../product-services/shared/models/productServicesRequestModel';
import { ProductServicesResponseModel } from '../../product-services/shared/models/productServicesResponseModel';
import { ProductCategoryService } from '../../product-services/shared/services/product-category.service';
import { ProductServicesService } from '../../product-services/shared/services/product-services.service';
import { ProductServiceGridModel } from '../shared/models/productServiceGridModel';
import { ChecklistService } from '../shared/services/checklist.service';
import { Store } from '@ngrx/store';
import { GetUserPermissionList } from 'src/app/state';
import { State as AppState } from 'src/app/state/app.state';
import _ from 'lodash';
import { CheckListGridParam } from '../../product-services/shared/models/checklist-grid-params';
import { PageInfo } from '../../user/shared/models/pageInfoModel';
import { SortInfo } from '../../user/shared/models/sortInfoModel';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';
import { IServiceGrid } from '../../product-services/shared/models/service-grid';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-checklist-product-services',
  templateUrl: './checklist-product-services.component.html',
  styleUrls: ['./checklist-product-services.component.scss']
})
export class ChecklistProductServicesComponent implements OnInit {

  public searchText: string = '';
  public selectedCategory: ProductCategoryResponseModel = <ProductCategoryResponseModel>{};
  public opened: boolean = false;
  public showClearButton: boolean = false;
  public allText: string = '';

  public gridData: ProductServiceGridModel[] = [];
  public data: GridDataResult = {data: [], total: 0};
  public productCategories: ProductCategoryResponseModel[];
  private productCategoriesFilled: boolean = false;

  sort: SortDescriptor[] = [
    {
      field: "serviceName",
      dir: "asc",
    },
  ];


  public pageSize: number = 25;
  public skip: number = 0;
  public page: number = 1;
  public userPermissionList: number[] = [];
  public serviceToRemoveChecklist = {serviceName: '', serviceId: 0};
  public sortInfo: SortInfo = { sortDirection: 1, SortColumn: 'serviceName' };
  constructor(public productCategoryService: ProductCategoryService,
              public productServiceService: ProductServicesService,
              private router: Router, public checklistService: ChecklistService, public toastService: ToastService,
              private store: Store<AppState>, private translationLoaderFacade: TranslationLoaderFacade, private translateService: TranslateService) {
                this.productCategories = [];
  }

  ngOnInit() {
    this.translateService.get('_General_All_Text_').subscribe(translatedString => {
      this.allText = translatedString;
    })

    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (!allUserPermissions) {
        throw Error('allUserPermissions is undefined!')
      }
      this.userPermissionList = allUserPermissions;
    });
    this.productCategoriesInitialization();

    const productServiceRequest: ProductServicesRequestModel = {
      productCategoryId: this.selectedCategory.productCategoryId,
      searchText: this.searchText
    };

    this.getProductsAndServices();
  }

  public productCategoriesInitialization() {
    
    this.productCategories.push({
      productCategoryId: 0,
      productCategoryDisplayName: this.allText
    })
    this.selectedCategory = this.productCategories[0];  
  }

  public sortProductCategories() {
    this.productCategories.sort((a, b) => {
      if (a.productCategoryDisplayName  === this.allText) {
        return -1;
      } else if (b.productCategoryDisplayName  === this.allText) {
        return 1;
      } else {
        return a.productCategoryDisplayName .localeCompare(b.productCategoryDisplayName );
      }
    });
}

  public getProductCategories(categories: ProductCategoryResponseModel[]) {
    categories.forEach(cat => this.productCategories.push(cat));
    this.productCategoriesFilled = true;
    this.sortProductCategories();
    
  }

   public assembleUniqueProductCategories(productsAndServices: ProductServicesResponseModel[]): ProductCategoryResponseModel[] {
    let productCategories: { productCategoryId: number; productCategoryDisplayName: string; }[] = [];
    productsAndServices.forEach(d => {
        productCategories.push({productCategoryId: d.productCategoryId, productCategoryDisplayName: d.productCategoryDisplayName})
    });
    return _.uniqBy(productCategories, function(e){
      return e.productCategoryId;
    })
  }
  public getProductsAndServices() {
    this.serviceToRemoveChecklist = {serviceName: '', serviceId: 0};;
    const params=this.getGridParams();
    this.productServiceService.getProductServices(params).subscribe(response => {
      this.data  =
      {
        data: response['data'],
        total: response['totalRowCount']
      }
      // Commented out the below as it was preventing the execution of the correct logic - CXDT-2223
      //if (!this.productCategoriesFilled) {
      //  console.log("this.data.data",this.data.data)
      //  this.getProductCategories(this.assembleUniqueProductCategories(this.data.data));
      //}
      if (!this.productCategoriesFilled) {
        this.getProductCategories(response.additionalData);
      }
      this.setPageInfo(response);

      const psGridData = this.data.data.map((service) => {

        const ps:ProductServiceGridModel = {
          serviceId: service.serviceId,
          serviceName: service.serviceDisplayName,
          checklistItemCount: service.checklistCount,
          productCategoryName: service.productCategoryDisplayName
        }

        return ps;
      });
      this.data  =
      {
        data:psGridData,
        total: this.data.total
      }

    });
  }
  setPageInfo(checklIst: IServiceGrid<ProductServicesResponseModel>) {
    if (checklIst.totalRowCount < this.skip) {
      this.page = 1;
      this.skip = 0;
    }
  }
  private getGridParams(): CheckListGridParam {
    let gridParams = new CheckListGridParam();
    gridParams.productCategoryId = this.selectedCategory.productCategoryId;
    gridParams.searchText = this.searchText;
    gridParams.pageInfo = new PageInfo();
    gridParams.pageInfo.Page = this.page;
    gridParams.pageInfo.PageSize = this.pageSize;
    gridParams.sortInfo = this.sortInfo;
    return gridParams;
  }
  

  public onSortChange(state: SortDescriptor[]) {
    this.sortInfo = {
      SortColumn: state[0]?.field,
      sortDirection: state[0]?.dir === 'asc' ? 1 : 2
    };
    this.sort = [{
      field: this.sortInfo.SortColumn,
      dir: this.sortInfo.sortDirection === 1 ? 'asc' : 'desc'
    }];
    this.getProductsAndServices();
  }

  public onProductCategoryChanged() {
    
    let productServiceRequest: ProductServicesRequestModel = {
      productCategoryId: this.selectedCategory.productCategoryId,
      searchText: this.searchText
    };

    this.getProductsAndServices();
  }

  public searchKeyWordChange(event: any) {

    if (event.key === 'Enter' || event.srcElement.value === ''){
      this.searchProductCategoryOrService();
    }

    this.updateSearchTextClearButtonVisibility(this.searchText);
    
  }

  private updateSearchTextClearButtonVisibility(searchText: string) {

    if(searchText && searchText !== '') {
        this.showClearButton = true;
    } else {
        this.showClearButton = false;
    }
  }

  public onClearSearchTextClicked(){
    this.searchText = "";
    this.showClearButton = false;
    this.searchProductCategoryOrService();
  }

  public searchProductCategoryOrService() {
    
    let productServiceRequest: ProductServicesRequestModel = {
      productCategoryId: this.selectedCategory.productCategoryId,
      searchText: this.searchText
    }

    this.getProductsAndServices();
  }

  public psTrackBy(index: number, item: ProductCategoryResponseModel) {
    return item.productCategoryId;
  }

  public onPageChange(state: any): void {
    this.page= (state.skip / this.pageSize) + 1;
    this.skip = state.skip;	
    this.getProductsAndServices();
    
  }

  public onChecklistAddOrEdit(dataItem: ProductServiceGridModel) {
    this.checklistService.setServiceId(dataItem.serviceId);
    this.checklistService.setServiceName(dataItem.serviceName);
    this.checklistService.setIsEdit(dataItem.checklistItemCount > 0);
    this.router.navigate(['admin/checklist/addchecklist']);
  }

  public close(status: string) {
    this.opened = false;

    if (status === 'Yes') {

      let productServiceRequest: ProductServicesRequestModel = {
        productCategoryId: this.selectedCategory.productCategoryId,
        searchText: this.searchText
      }
      
      this.checklistService.removeChecklistForService(this.serviceToRemoveChecklist.serviceId).subscribe({
        next: () => {
          this.getProductsAndServices();
          this.toastService.showSuccess('_Checklist_Checklist_Deleted_Successfully_Ts_Text_');
        },
        error: () => {
          this.toastService.showError('_Checklist_Checklist_Deletion_Failed_Ts_Text_');
        }
      });
    } else {
      this.serviceToRemoveChecklist = {serviceName: '', serviceId: 0};
    }
  }

  removeChecklist(dataItem: any) {
    this.serviceToRemoveChecklist = { serviceId: dataItem.serviceId, serviceName: dataItem.serviceName};
    this.opened = true;
  }

}
